import React, { useState } from 'react';
import { Box, Button, Paper, Stack, TextField, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import api from '../services/api';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: 'calc(100vh - 260px)', display: 'grid', placeItems: 'center', px: 2, py: { xs: 5, md: 7 }, bgcolor: '#f5f7fb' }}>
      <Paper variant="outlined" sx={{ p: 4, borderRadius: 2, boxShadow: '0 20px 50px rgba(7,24,45,0.08)', width: '100%', maxWidth: 480, borderColor: 'rgba(7,24,45,0.08)' }}>
        {sent ? (
          <Stack spacing={2} alignItems="center">
            <Typography variant="h5" fontWeight={700}>Check your inbox</Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              If that email is registered, we've sent a password reset link. It expires in 1 hour.
            </Typography>
            <Button component={RouterLink} to="/login" variant="outlined">
              Back to login
            </Button>
          </Stack>
        ) : (
          <Stack spacing={2} component="form" onSubmit={handleSubmit}>
            <Typography variant="h5" fontWeight={700}>Forgot your password?</Typography>
            <Typography variant="body2" color="text.secondary">
              Enter your email and we'll send you a reset link.
            </Typography>
            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
              autoFocus
            />
            {error && <Typography variant="body2" color="error">{error}</Typography>}
            <Button type="submit" variant="contained" color="secondary" size="large" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </Button>
            <Typography variant="body2" color="text.secondary">
              Remember it?{' '}
              <Button component={RouterLink} to="/login" size="small">Sign in</Button>
            </Typography>
          </Stack>
        )}
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
